import classNames from 'classnames';
import { LinkProps } from 'next/link';
import { ButtonHTMLAttributes, ReactNode, forwardRef } from 'react';
import Link from '@/shared/components/shared/Link';
import Spinner from '@/shared/components/shared/Spinner';

export type Props = ButtonHTMLAttributes<HTMLButtonElement> &
    Partial<LinkProps> & {
        /**
         * Какой тег рендерить
         */
        tag?: keyof JSX.IntrinsicElements | typeof Link;

        /**
         * Геометрия кнопки
         */
        geometryVariant?: 'default' | 'wide';
        /**
         * Цветовая тема кнопки
         */
        variant?:
            | 'default'
            | 'primary'
            | 'primary-filled'
            | 'blue'
            | 'outline'
            | 'white'
            | 'outline-primary'
            | 'dark-filled'
            | 'dark-blue';
        /**
         * Размер
         */
        size?: 'default' | 'sm' | 'xs';
        asyncActionActive?: boolean;
        icon?: ReactNode;
        target?: string;
    };

const ConstructorButton = forwardRef<HTMLButtonElement, Props>(
    (
        {
            children,
            variant = 'default',
            tag = 'button',
            geometryVariant = 'default',
            size = 'default',
            asyncActionActive = false,
            icon,
            ...props
        },
        ref,
    ) => {
        const Component = tag as any;

        return (
            <Component
                type={tag === 'button' ? 'button' : undefined}
                {...props}
                ref={ref}
                className={classNames(
                    'constructor-btn',
                    `constructor-btn-${variant}`,
                    `constructor-btn-geometry-${geometryVariant}`,
                    `constructor-btn-size-${size}`,
                    props.className,
                    { 'is-async-action-active': asyncActionActive },
                )}
            >
                {icon && <span className="constructor-btn__icon">{icon}</span>}
                <span className="constructor-btn__text text-m">{children}</span>
                {asyncActionActive && <Spinner />}
            </Component>
        );
    },
);

ConstructorButton.displayName = 'ConstructorButton';

export default ConstructorButton;
